import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph, ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId, getcompanyId, getuserId } from '../../utility/tokenUtility';
import Axios from '../data-access/genericAxios';
import dayjs from 'dayjs';
async function getWorkGroupDetails(model) {
  const response = await Axios.get(`${FemsGraph}/api/femworkgroupdetails`);
  return response;
};

async function assetNumberGeneration(model) {
  // model attribute for requestbody
  const response = await Axios.post(`${FemsGraph}/api/femassetnumbergenerations`, model);
  return response;
};

function compareObjects(obj1, obj2) {
  /**
   * Compare two objects and return the keys with changed values in a single string.
   *
   * @param {Object} obj1 - The first object to compare.
   * @param {Object} obj2 - The second object to compare.
   * @returns {String} - A comma-separated string of keys with changed values.
   */
  const changedKeys = [];

  // Compare keys that exist in both objects
  Object.keys(obj1).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      // Handle nested objects comparison (deep comparison)
      if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
        if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
          changedKeys.push(key);
        }
      } else if (obj1[key] !== obj2[key]) {
        changedKeys.push(key);
      }
    }
  });

  // Return the keys as a single string, separated by commas
  return changedKeys.join(', ');
}

function isDataChanged(obj1, obj2) {
  /**
   * Compare two objects and return true if they have changed values, false otherwise.
   *
   * @param {Object} obj1 - The first object to compare.
   * @param {Object} obj2 - The second object to compare.
   * @returns {Boolean} - True if the objects have changed values, false otherwise.
   */
  const changedKeys = [];

  // Compare keys that exist in both objects
  Object.keys(obj1).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      // Handle nested objects comparison (deep comparison)
      if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
        if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
          changedKeys.push(key);
        }
      } else if (obj1[key] !== obj2[key]) {
        changedKeys.push(key);
      }
    }
  });

  // Return true if there are changed keys, false otherwise
  return changedKeys.length > 0;
}

// Fetch the Grid Values from API
const assetListing = async (assetType, pageIndex, pageSize, filterModel, sortModel) => {
  let assetCategory = '';
  if (assetType === "/assetsFEM") {
    assetCategory = FemsGraph;
  } else if (assetType === "/assetsBEM") {
    assetCategory = BemsGraph;
  }
  else {
    return;
  }
  const facilityId = getFacilityId("facilityid");
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetAssetRegisterListAll/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

const exportData = async (assetType, filterModel, sortModel) => {
  let assetCategory = '';
  if (assetType === "/assetsFEM") {
    assetCategory = FemsGraph;
  } else if (assetType === "/assetsBEM") {
    assetCategory = BemsGraph;
  }
  else {
    return;
  }
  const facilityId = getFacilityId("facilityid");
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetAssetExport/${facilityId}?filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`, config);
    return response;
  } catch (error) {
    console.error(error);
  }
};


const exportDataForWorkGroup = async (assetType, workgroupId, filterModel, sortModel) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  const facilityId = getFacilityId("facilityid");
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetCommonExportWorkGroup/${facilityId}/${workgroupId}?filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

// Fetch the Work Group Code from API
const workGroupCodeDetails = async (assetType, id) => {
  let assetCategory = '';
  if (assetType === "/assetsFEM") {
    assetCategory = FemsGraph;
  } else if (assetType === "/assetsBEM") {
    assetCategory = BemsGraph;
  } else {
    return;
  }
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${assetCategory}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${id}`, config);

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
// Fetch the Work Order details from API
const filterDetails = async (serviceType) => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(
      `${FemsGraph}/api/CommonLov/GetCommonLovList`,
      config
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch data: ${error?.message}`);
  }
};
const partReplacement = async (facilityId) => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(
      `${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderItemDetailsFetchList/${facilityId},1,100000`,
      config
    );
    return response?.data;
  } catch (error) {
    console.error(`Failed to fetch data: ${error.message}`);
  }
};
const getTaskcdeDetails = async (workgroupdetailsId) => {
  const facilityId = getFacilityId("facilityid");

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(
      `${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderTaskCodeFetchList/${facilityId},${workgroupdetailsId},1,100000`,
      config

    );
    return response?.data;
  } catch (error) {
    console.error(`Failed to fetch data: ${error?.message}`);
  }
};

// Employee Details
const getEmployeeDetails = async () => {
  const facilityId = getFacilityId("facilityid");
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(
      `${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId}`,
      config
    );

    return response?.data;

  } catch (error) {
    console.error(`Failed to fetch data: ${error?.message}`);
  }
};
const getVendorDetails = async () => {

  const companyId = getcompanyId('companyId')
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(
      `${MasterGraph}/api/GraphMaspomvendors/GetMaspomvendorsByFacilityId/${companyId}?Size=100000`,
      config

    );

    return response?.data;

  } catch (error) {
    console.error(`Failed to fetch data: ${error?.message}`);
  }
};


const getWorkorderReport = async (filterDetailsData, level) => {
  const companyId = getcompanyId('companyId')
  const userId = getuserId('userId')
  // Remove groupBy and serviceId from filterDetailsData and convert dates
  const { serviceId, fromDate, toDate, ...filteredData } = filterDetailsData;

  // Convert dates to the correct format (assuming DD/MM/YYYY input)
  const formatDate = (date) => {
    const parsedDate = dayjs(date, "DD/MM/YYYY", true);
    return parsedDate.isValid() ? parsedDate.format("YYYY/MM/DD") : null;
  };

  // Reassign the formatted dates back into the filterDetailsData
  const formattedFromDate = formatDate(fromDate);
  const formattedToDate = formatDate(toDate);
  let updatedFilterDetailsData;
  // Update the filterDetailsData with formatted dates
  updatedFilterDetailsData = {
    ...filteredData,
    fromDate: formattedFromDate,
    toDate: formattedToDate,
    facilityid:
      filterDetailsData.hospitalid,

  };
  const baseURL = serviceId === "FEMS" ? FemsGraph : BemsGraph;

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    let response;
    if (level === 1) {

      const API_Payload = {
        hospitalName: updatedFilterDetailsData?.hospitalName,
        hospitalid: updatedFilterDetailsData?.hospitalid,
        facilityid: updatedFilterDetailsData?.hospitalid,
        Userid: userId,
        workordercategory: updatedFilterDetailsData?.workordercategory === 3 ? null : updatedFilterDetailsData?.workordercategory,
        groupBy: updatedFilterDetailsData?.groupBy === 6 ? null : updatedFilterDetailsData?.groupBy,
        workOrderType: updatedFilterDetailsData?.workOrderType,
        scheduleWorkorderReportLevelOneLists: updatedFilterDetailsData?.scheduleWorkorderReportLevelOneLists,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        serviceId: "",
        level: filterDetailsData?.Level === "HQ" ? 2 : 1,
        companyId: companyId,
        token: token,
        priority: updatedFilterDetailsData?.priority === 3 || updatedFilterDetailsData?.priority === "all" ? null : updatedFilterDetailsData?.priority,
        options: updatedFilterDetailsData?.options || ""
      };
      if (serviceId === "All") {

        const fems = await axios.post(
          `${FemsGraph}/api/GraphWorkorderReport/WorkorderReportLevelOneList`,
          API_Payload,
          config
        );
        const bems = await axios.post(
          `${BemsGraph}/api/GraphWorkorderReport/WorkorderReportLevelOneList`,
          API_Payload,
          config
        );

        let levelType = filterDetailsData?.Level === "HQ" ? 2 : 1

        if (levelType === 2) {

          let mergedResponse = {
            ...fems?.data, // Copy all data from fems response
            scheduleWorkorderReportLevelOneLists: [
              ...(fems?.data?.workorderLevelHQLists || []),
              ...(bems?.data?.workorderLevelHQLists || [])
            ], // Merge the schedule lists from both fems and bems
            unScheduleWorkorderReportLevelOneLists: [
              ...(fems?.data?.workorderLevelHQLists || []),
              ...(bems?.data?.workorderLevelHQLists || [])
            ], // Merge the unscheduled lists from both fems and bems
            workorderReportGroupByAllLists: [
              ...(fems?.data?.workorderReportGroupByAllLists || []),
              ...(bems?.data?.workorderReportGroupByAllLists || [])
            ],
            workorderReportDetailsListVMs: [
              ...(fems?.data?.workorderReportDetailsListVMs || []),
              ...(bems?.data?.workorderReportDetailsListVMs || [])
            ]
          };
          return mergedResponse;

        } else {
          let mergedResponse = {
            ...fems?.data, // Copy all data from fems response
            scheduleWorkorderReportLevelOneLists: [
              ...(fems?.data?.scheduleWorkorderReportLevelOneLists) || [],
              ...(bems?.data?.scheduleWorkorderReportLevelOneLists) || []
            ], // Merge the schedule lists from both fems and bems
            unScheduleWorkorderReportLevelOneLists: [
              ...(fems?.data?.unScheduleWorkorderReportLevelOneLists) || [],
              ...(bems?.data?.unScheduleWorkorderReportLevelOneLists) || []
            ], // Merge the unscheduled lists from both fems and bems
            workorderReportGroupByAllLists: [
              ...(fems?.data?.workorderReportGroupByAllLists || []),
              ...(bems?.data?.workorderReportGroupByAllLists || [])
            ], // Merge the both unscheduled and scheduled lists from both fems and bems
            workorderReportDetailsListVMs: [
              ...(fems?.data?.workorderReportDetailsListVMs || []),
              ...(bems?.data?.workorderReportDetailsListVMs || [])
            ]
          };

          return mergedResponse;

        }



      } else {

        response = await axios.post(
          `${baseURL}/api/GraphWorkorderReport/WorkorderReportLevelOneList`,
          API_Payload,
          config
        );

        let levelType = filterDetailsData?.Level === "HQ" ? 2 : 1

        if (levelType === 2) {

          let mergedResponse = {
            ...response?.data, // Copy all data from fems response
            scheduleWorkorderReportLevelOneLists: [
              ...response?.data?.workorderLevelHQLists || [],
            ], // Merge the schedule lists from both fems and bems
            unScheduleWorkorderReportLevelOneLists: [
              ...response?.data?.workorderLevelHQLists || []
            ] // Merge the unscheduled lists from both fems and bems
          };
          return mergedResponse;

        } else {
          let mergedResponse = {
            ...response?.data, // Copy all data from fems response
            scheduleWorkorderReportLevelOneLists: [
              ...response?.data?.scheduleWorkorderReportLevelOneLists || []
            ], // Merge the schedule lists from both fems and bems
            unScheduleWorkorderReportLevelOneLists: [
              ...response?.data?.unScheduleWorkorderReportLevelOneLists || []
            ] // Merge the unscheduled lists from both fems and bems
          };
          return mergedResponse;

        }

      }
    }

    //       else if (level === 2) {
    //         updatedFilterDetailsData = {
    //           ...filteredData,
    //           fromDate: formattedFromDate,
    //           toDate: formattedToDate,
    //           facilityid:
    //             filterDetailsData?.hospitalid,
    //         };

    //         if(serviceId === "All"){
    //  let femsPayload = {
    //             hospitalName: updatedFilterDetailsData?.hospitalName,
    //             hospitalid: updatedFilterDetailsData?.hospitalid,
    //             facilityid: updatedFilterDetailsData?.hospitalid,
    //             workordercategory: updatedFilterDetailsData?.workordercategory,
    //             groupBy: updatedFilterDetailsData?.groupBy,
    //             workOrderType:updatedFilterDetailsData?.workOrderType === 3 ? null : updatedFilterDetailsData?.workOrderType,
    //             fromDate: formattedFromDate,
    //             toDate: formattedToDate,
    //             workOrderStatus: updatedFilterDetailsData?.workOrderStatus,

    //         };

    //         let bemsPayload = {
    //           hospitalName: updatedFilterDetailsData?.hospitalName,
    //           hospitalid: updatedFilterDetailsData?.hospitalid,
    //           facilityid: updatedFilterDetailsData?.hospitalid,
    //           workordercategory: updatedFilterDetailsData?.workordercategory,
    //           groupBy: updatedFilterDetailsData?.groupBy,
    //           workOrderType:updatedFilterDetailsData?.workOrderType === 3 ? null : updatedFilterDetailsData?.workOrderType,
    //           scheduleWorkorderReportLevelOneLists: updatedFilterDetailsData?.scheduleWorkorderReportLevelOneLists,
    //           fromDate: formattedFromDate,
    //           toDate: formattedToDate,
    //           workOrderStatus: updatedFilterDetailsData?.workOrderStatus,

    //       };

    //           const fems = await axios.post(
    //            `${FemsGraph}/api/GraphWorkorderReport/WorkorderReportLevelTwoList`,
    //             femsPayload,
    //             config
    //           );
    //          const bems = await axios.post(
    //           `${BemsGraph}/api/GraphWorkorderReport/WorkorderReportLevelTwoList`,
    //           bemsPayload,
    //           config
    //         );
    //         let mergedResponse = {
    //           ...fems?.data, // Copy all data from fems response
    //           scheduleWorkorderReportAssetTypeLevelTwoLists: [
    //             ...fems?.data?.scheduleWorkorderReportAssetTypeLevelTwoLists || [], 
    //             ...bems?.data?.scheduleWorkorderReportAssetTypeLevelTwoLists || []
    //           ], // Merge the schedule lists from both fems and bems
    //           unScheduleWorkorderReportAssetTypeLevelTwoLists: [
    //             ...fems?.data?.unScheduleWorkorderReportAssetTypeLevelTwoLists || [], 
    //             ...bems?.data?.unScheduleWorkorderReportAssetTypeLevelTwoLists || []
    //           ] // Merge the unscheduled lists from both fems and bems
    //         };
    //         return mergedResponse;

    //         }else{

    //           const getresponse = await axios.post(
    //             `${baseURL}/api/GraphWorkorderReport/WorkorderReportLevelTwoList`,
    //             updatedFilterDetailsData,
    //             config
    //           );
    //           return getresponse?.data;
    //         }
    //       }

    else if (level === 2) {
      updatedFilterDetailsData = {
        ...filteredData,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        facilityid: filterDetailsData?.hospitalid,
      };

      if (serviceId === "All") {
        let femsPayload = {
          hospitalName: updatedFilterDetailsData?.hospitalName,
          hospitalid: updatedFilterDetailsData?.hospitalid,
          Userid: userId,
          facilityid: updatedFilterDetailsData?.hospitalid,
          workordercategory: updatedFilterDetailsData?.workordercategory,
          groupBy: updatedFilterDetailsData?.groupBy,
          workOrderType: updatedFilterDetailsData?.workOrderType,
          // workOrderType: updatedFilterDetailsData?.workOrderType === 3 ? null : updatedFilterDetailsData?.workOrderType,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
          token: token,
          workOrderStatus: updatedFilterDetailsData?.workOrderStatus,
          options: updatedFilterDetailsData?.options || ""

        };

        let bemsPayload = {
          ...femsPayload,
          scheduleWorkorderReportLevelOneLists: updatedFilterDetailsData?.scheduleWorkorderReportLevelOneLists,
        };

        const [fems, bems] = await Promise.all([
          axios.post(`${FemsGraph}/api/GraphWorkorderReport/WorkorderReportLevelTwoList`, femsPayload, config),
          axios.post(`${BemsGraph}/api/GraphWorkorderReport/WorkorderReportLevelTwoList`, bemsPayload, config),
        ]);

        // Explicit list of keys to merge
        const listKeys = [
          "unScheduleWorkorderReportWorkGroupLevelTwoLists",
          "scheduleWorkorderReportWorkGroupLevelTwoLists",
          "workorderReportAssetAgeLevelTwoLists",
          "workorderReportDepartmentLevelTwoLists",
          "workorderReportWorkGroupLevelTwoLists",
          "WorkorderReportAssetTypeLevelTwoLists",
          "unScheduleWorkorderReportAssetTypeLevelTwoLists",
          "scheduleWorkorderReportAssetTypeLevelTwoLists"
        ];

        // Helper function to merge specific keys
        const mergeLists = (femsData, bemsData) => {

          let mergedData = { ...femsData };

          listKeys.forEach((key) => {
            mergedData[key] = [
              ...(femsData[key] || []),
              ...(bemsData[key] || [])
            ];
          });

          return mergedData;
        };
        let mergedResponse = mergeLists(fems?.data, bems?.data);

        return mergedResponse;
      } else {
        const getresponse = await axios.post(
          `${baseURL}/api/GraphWorkorderReport/WorkorderReportLevelTwoList`,
          updatedFilterDetailsData,
          config
        );
        return getresponse?.data;
      }
    }

    //  else if (level === 3) {

    //     updatedFilterDetailsData = {
    //       ...filteredData,
    //       fromDate: formattedFromDate,
    //       toDate: formattedToDate,
    //       facilityid:
    //         filterDetailsData?.hospitalid,
    //     };

    //     if(serviceId === "All"){

    //       let femsPayload = {
    //         hospitalName: updatedFilterDetailsData?.hospitalName,
    //         hospitalid: updatedFilterDetailsData?.hospitalid,
    //         facilityid: updatedFilterDetailsData?.hospitalid,
    //         workordercategory: updatedFilterDetailsData?.workordercategory,
    //         groupBy: updatedFilterDetailsData?.groupBy,
    //         workOrderType:updatedFilterDetailsData?.workOrderType === 3 ? null : updatedFilterDetailsData?.workOrderType,
    //         fromDate: formattedFromDate,
    //         toDate: formattedToDate,
    //         workOrderStatus: updatedFilterDetailsData?.workOrderStatus,
    //         typecodeId: updatedFilterDetailsData?.typecodeId
    //     };

    //     let bemsPayload = {
    //       hospitalName: updatedFilterDetailsData?.hospitalName,
    //       hospitalid: updatedFilterDetailsData?.hospitalid,
    //       facilityid: updatedFilterDetailsData?.hospitalid,
    //       workordercategory: updatedFilterDetailsData?.workordercategory,
    //       groupBy: updatedFilterDetailsData?.groupBy,
    //       workOrderType:updatedFilterDetailsData?.workOrderType === 3 ? null : updatedFilterDetailsData?.workOrderType,
    //       fromDate: formattedFromDate,
    //       toDate: formattedToDate,
    //       workOrderStatus: updatedFilterDetailsData?.workOrderStatus,
    //       typecodeId: updatedFilterDetailsData?.typecodeId
    //   };


    //       const fems = await axios.post(
    //         `${FemsGraph}/api/GraphWorkorderReport/GetWorkorderReportLevelThreeList`,
    //         femsPayload,
    //         config
    //       );

    //      const bems = await axios.post(
    //       `${BemsGraph}/api/GraphWorkorderReport/GetWorkorderReportLevelThreeList`,
    //       bemsPayload,
    //       config
    //     );

    //     let mergedResponse = {
    //       ...fems.data, // Copy all data from fems response
    //       scheduleWorkorderReportAssetTypeLevelThreeLists: [
    //         ...fems?.data?.scheduleWorkorderReportAssetTypeLevelThreeLists || [], 
    //         ...bems?.data?.scheduleWorkorderReportAssetTypeLevelThreeLists || [],
    //       ], // Merge the schedule lists from both fems and bems
    //       unScheduleWorkorderReportAssetTypeLevelThreeLists: [
    //         ...fems?.data?.unScheduleWorkorderReportAssetTypeLevelThreeLists || [], 
    //         ...bems?.data?.unScheduleWorkorderReportAssetTypeLevelThreeLists || []
    //       ] // Merge the unscheduled lists from both fems and bems
    //     };
    //     return mergedResponse;

    //     }else{

    //       response = await axios.post(
    //         `${baseURL}/api/GraphWorkorderReport/GetWorkorderReportLevelThreeList`,
    //         updatedFilterDetailsData,
    //         config
    //       );
    //       return response?.data;
    //     }


    //   }

    else if (level === 3) {
      updatedFilterDetailsData = {
        ...filteredData,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        facilityid: filterDetailsData?.hospitalid,
      };

      if (serviceId === "All") {
        let femsPayload = {
          hospitalName: updatedFilterDetailsData?.hospitalName,
          hospitalid: updatedFilterDetailsData?.hospitalid,
          facilityid: updatedFilterDetailsData?.hospitalid,
          workordercategory: updatedFilterDetailsData?.workordercategory,
          groupBy: updatedFilterDetailsData?.groupBy,
          workOrderType: updatedFilterDetailsData?.workOrderType,
          // workOrderType: updatedFilterDetailsData?.workOrderType === 3 ? null : updatedFilterDetailsData?.workOrderType,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
          token: token,
          Userid: filterDetailsData?.Userid || "",
          workOrderStatus: updatedFilterDetailsData?.workOrderStatus,
          typecodeId: updatedFilterDetailsData?.typecodeId || "",
          workGroupId: updatedFilterDetailsData?.workGroupId || "",
          departmentId: updatedFilterDetailsData?.departmentId || "",
          assetStartAge: updatedFilterDetailsData?.AssetStartAge === 0 ? 1 : updatedFilterDetailsData?.AssetStartAge || "",
          assetEndAge: updatedFilterDetailsData?.AssetEndAge || "",
          options: updatedFilterDetailsData?.options || ""

        };

        let bemsPayload = { ...femsPayload };

        const [fems, bems] = await Promise.all([
          axios.post(`${FemsGraph}/api/GraphWorkorderReport/GetWorkorderReportLevelThreeList`, femsPayload, config),
          axios.post(`${BemsGraph}/api/GraphWorkorderReport/GetWorkorderReportLevelThreeList`, bemsPayload, config),
        ]);

        // Explicit list of Level 3 keys to merge
        const listKeys = [
          "woLevelThreeLists",
          "scheduleWorkorderReportAssetTypeLevelThreeLists",
          "unScheduleWorkorderReportAssetTypeLevelThreeLists",
          "unScheduleWorkorderReportWorkGroupLevelThreeLists",
          "scheduleWorkorderReportWorkGroupLevelThreeLists",
        ];

        // Helper function to merge specific keys
        const mergeLists = (femsData, bemsData) => {
          let mergedData = { ...femsData };

          listKeys.forEach((key) => {
            mergedData[key] = [
              ...(femsData[key] || []),
              ...(bemsData[key] || [])
            ];
          });

          return mergedData;
        };

        let mergedResponse = mergeLists(fems?.data, bems?.data);
        return mergedResponse;
      } else {
        const response = await axios.post(
          `${baseURL}/api/GraphWorkorderReport/GetWorkorderReportLevelThreeList`,
          updatedFilterDetailsData,
          config
        );
        return response?.data;
      }
    }

    else if (level === 4 && filterDetailsData?.options === 2) {
      const facilityID = filterDetailsData?.hospitalid;
      const token = getAuthToken("id_token");
      const workOrderId = filterDetailsData?.workOrderId;
      const checkGraph = filterDetailsData?.service === "FEMS" ? FemsGraph : BemsGraph
      const detailsCategoryType = filterDetailsData?.category === "UnScheduled" ? "GetUnScheduleWorkorderFetchByWorkOrderId" : "GetScheduleWorkorderFetchByWorkOrderId"
      response = await axios.get(
        `${checkGraph}/api/GraphWorkorderReport/${detailsCategoryType}/${facilityID},${workOrderId},${token}`,
        config
      );

      return response?.data;

    } else if (level === 4 && filterDetailsData?.options === 1) {
      const facilityID = filterDetailsData?.hospitalid;
      const token = getAuthToken("id_token");
      const workOrderId = filterDetailsData?.workOrderId;
      const checkGraph = filterDetailsData?.service === "FEMS" ? FemsGraph : BemsGraph
      const categoryType = filterDetailsData?.workordercategory === 1 ? "GetUnScheduleWorkorderFetchByWorkOrderId" : "GetScheduleWorkorderFetchByWorkOrderId"
      response = await axios.get(
        `${checkGraph}/api/GraphWorkorderReport/${categoryType}/${facilityID},${workOrderId},${token}`,
        config
      );

      return response?.data;
    }

  } catch (error) {
    console.error(`Failed to fetch data: ${error?.message}`);
  }
};

// Filter the rows based on workgroup code details
const workgroupFilteredRows = async (assetType, workgroupId, filterModel, sortModel, pageIndex, pageSize) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  const facilityId = getFacilityId("facilityid");
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetAssetListByWorkGroup/${facilityId}/${workgroupId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

// Fetch the Asset Detail from API
const assetViewDetail = async (assetType, assetId) => {
  // const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  let assetCategory;
  if (assetType === '/assetsFEM') {
    assetCategory = FemsGraph;
  } else if (assetType === '/assetsBEM') {
    assetCategory = BemsGraph;
  } else {
    return;
  }
  const facilityId = getFacilityId("facilityid");
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetAssetDetailsByAssetId/${facilityId}/${assetId}`, config);

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

//To add the Historical cost Asset data
const addHistoricalCost = async (assetType, payload) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph
  const checkFemOrBem = assetType === "/assetsFEM" ? "fem" : "bem";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    //GrapBemassethistorymaintenances
    const response = await axios.post(`${assetCategory}/api/${checkFemOrBem}assethistorymaintenances`, payload, config);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

//To edit the Historical cost Asset data in the grid table

const editHistoricalcostData = async (assetType, id, payload) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph
  const checkFemOrBem = assetType === "/assetsFEM" ? "fem" : "bem";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.put(`${assetCategory}/api/${checkFemOrBem}assethistorymaintenances/${id}`, payload, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

//To edit the Historical cost Asset data in the grid table
const gethistoricalAssetDetail = async (assetType, id) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  const checkFemOrBem = assetType === "/assetsFEM" ? "fem" : "bem";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${assetCategory}/api/${checkFemOrBem}assethistorymaintenances/${id}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

//To get all Historical cost Asset data in the grid table
const getAllHistoricalAssetDetail = async (type, assetId) => {
  const assetCategory = type === "/assetsFEM" ? FemsGraph : BemsGraph;
  const checkFemOrBem = type === "/assetsFEM" ? "GraphFem" : "GrapBem"; //'h' is the diff b/w two apis 
  const facilityId = getFacilityId("facilityid");

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${assetCategory}/api/${checkFemOrBem}assethistorymaintenances/GetAssetHistoryMaintenances/${facilityId}/${assetId}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

const getSheduledList = async (assetType, assetId) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetAssetListScheduleById/${assetId}?size=10000`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

const getUnSheduldedList = async (assetType, assetId) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },

    };
    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetAssetListUnScheduleById/${assetId}?size=10000`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

const getRoutineInspectionList = async (assetType, assetId) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },

    };
    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetRoutineinspectionWOId/${assetId}?size=10000`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

const gettestingandcommissionhistory = async (assetType, assetId) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },

    };
    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/GetTestingandcommissionId/${assetId}?size=10000`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};


const getcontracthistorydetails = async (assetType, assetId) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  const checkFemOrBem = assetType === "/assetsFEM" ? "api/graph/GetContractRegisterfemsbyAssetId" : "api/ContractRegisterbems/GetContractRegisterbemsbyAssetId";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },

    };
    const response = await axios.get(`${assetCategory}/${checkFemOrBem}/${assetId}`, config);

    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
const getriskmanagmentdetails = async (assetId) => {

  const companyId = getcompanyId();
  const facilityId = getFacilityId();
  const UserId = getuserId();

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },

    };
    const response = await axios.get(`${BemsGraph}/api/GraphAssetregister/GetBemassechecklist/${companyId}/${UserId}/${facilityId}/${token}/${assetId}`, config);

    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

const updateresponseTypeID = async (assetType, assetId, payload) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  const checkFemOrBem = assetType === "/assetsFEM" ? "UpdateFemppmscheduledetailsresponsetype" : "UpdateBemppmscheduledetailsresponsetype";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },

    };
    const response = await axios.put(`${assetCategory}/api/Graphppmscheduledetails/${checkFemOrBem}/${assetId}`, payload, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

const updatePPMstatusForTrackerTable = async (assetType, assetId) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },

    };
    const url = assetType === "/assetsFEM" ? "api/femppmscheduletracks/GetFemppmscheduletrackppmrequriedno" : "api/bemppmscheduletracks/GetBemppmscheduletrackppmrequriedno"
    const response = await axios.delete(`${assetCategory}/${url}/${assetId}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};


const updatePPMTableandTrackerTableTypeocdeid = async (assetId) => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },

    };
    const userid = getuserId("userid");

    const response = await axios.get(`${BemsGraph}/api/PPMScheduleReport/UpdateppmplannerandDeleteTrack/${assetId}/${userid}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};


const updateppmplannerisdeleted = async (assetType, id) => {
  const assetCategory = assetType === "/assetsFEM" ? "FEMS" : "BEMS"
  const userId = localStorage.getItem("UserId");
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    let endpoint;
    if (assetCategory === "FEMS") {
      endpoint = `${FemsGraph}/api/femppmscheduletracks/DeleteppmplannerandTrackandSWO/${id}/${userId}`;
    }
    else {
      endpoint = `${BemsGraph}/api/bemppmscheduletracks/DeleteppmplannerandTrackandSWO/${id}/${userId}`;
    }

    await axios({
      method: 'put',
      url: endpoint,
      headers: config.headers,
    });

  } catch (error) {
    console.error(error);
  }
};


//get the both sheduled and unscheduled asset maintance history
const getAssetMaintanceHistory = async (assetType, assetId) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const [scheduledResponse, unscheduledResponse] = await Promise.allSettled([
      axios.get(`${assetCategory}/api/GraphAssetregister/GetAssetListScheduleById/${assetId}`, config),
      axios.get(`${assetCategory}/api/GraphAssetregister/GetAssetListUnScheduleById/${assetId}`, config),
    ]);

    const result = [];

    if (scheduledResponse.status === 'fulfilled') {
      result.push(...scheduledResponse.value.data);
    }

    if (unscheduledResponse.status === 'fulfilled') {
      result.push(...unscheduledResponse.value.data);
    }
    return result;
  } catch (error) {
    console.error(error);
  }
};

const getAuditTrail = async (assetType, assetId) => {
  const assetCategory = assetType === "/assetsFEM" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const facilityId = getFacilityId("facilityid");
    const femorbem = assetType === "/assetsFEM" ? "GetFemassetaudittrailsbyFacilityidandAssetID" : "GetBemassetaudittrailsbyFacilityidandAssetID";
    const response = await axios.get(`${assetCategory}/api/GraphAssetregister/${femorbem}/${facilityId}/${assetId}?size=10000`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
}

const getHospitalName = async () => {
  try {

    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const companyid = getcompanyId("companyid");
    const userid = getuserId("userid");
    const response = await axios.get(
      `${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyid}/${userid}`,
      config
    );

    return response?.data;

  }
  catch (error) {
    console.error(error);
  }

};

// Asset API Method
const getAssetReport = async (assetDetailsData, level) => {
  const { AssetType, fromDate, toDate, groupById, ...assetData } = assetDetailsData;
  // Convert dates to the correct format (assuming DD/MM/YYYY input)
  const formatDate = (date) => {
    const parsedDate = dayjs(date, "DD/MM/YYYY", true);
    return parsedDate.isValid() ? parsedDate.format("YYYY/MM/DD") : null;
  };

  // Reassign the formatted dates back into the filterDetailsData
  const formattedFromDate = formatDate(fromDate);
  const formattedToDate = formatDate(toDate);
  let updatedAssetDetailsData;

  updatedAssetDetailsData = {
    ...assetData,
    fromDate: formattedFromDate,
    toDate: formattedToDate,

  };
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    let response;
    if (AssetType === "FEMS") {

      if (level === 1 && groupById == 11) {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
          // authorized: true,

        };

        const getresponseAsset = await axios.get(
          `${FemsGraph}/api/AssetReport/GetAssertReportLevelTwo`,
          {
            params: updatedAssetDetailsData,
            ...config
          }
        );
        return getresponseAsset?.data;

      }
      if (level === 1 && groupById != 11) {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,

        };

        response = await axios.get(
          `${FemsGraph}/api/AssetReport/GetAssertReportTypeCode`,

          {
            params: updatedAssetDetailsData,
            ...config
          }
        );
        return response?.data;

      }
      if (level === 2) {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
          // authorized: true,

        };

        const getresponseAsset = await axios.get(
          `${FemsGraph}/api/AssetReport/GetAssertReportLevelTwo`,
          {
            params: updatedAssetDetailsData,
            ...config
          }
        );
        return getresponseAsset?.data;
      }

      if (level === 3) {
        if (assetData) {
          const Facilityid =
            assetDetailsData.facilityid;
          const AssetId = assetDetailsData.assetId;

          response = await axios.get(
            `${FemsGraph}/api/GraphAssetregister/GetAssetDetailsByAssetId/${Facilityid}/${AssetId}`,
            config
          );
        }
      }
      if (level === "Summary") {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        };
        const bemsResponse = await axios.get(`${FemsGraph}/api/AssetReport/GetAssertReportTypeCode`, {
          params: updatedAssetDetailsData,
          ...config,
        });
        const updatedData = bemsResponse?.data?.assetAnalysisTypeCodeList?.map(({ id, facilityId, typeCodeId, assetStatusId, ...rest }) => rest);
        const response = { ...bemsResponse?.data, assetAnalysisTypeCodeList: updatedData };
        return response;

      }
    }
    else if (AssetType === "BEMS") {
      if (level === 1 && groupById != 11) {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        };

        response = await axios.get(
          `${BemsGraph}/api/AssetReport/GetAssertReportTypeCode`,
          {
            params: updatedAssetDetailsData,
            ...config
          }
        );

        return response?.data;

      }
      if (level === 1 && groupById == 11) {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
          // authorized: true,

        };

        const getresponseAsset = await axios.get(
          `${BemsGraph}/api/AssetReport/GetAssertReportLevelTwo`,
          {
            params: updatedAssetDetailsData,
            ...config
          }
        );
        return getresponseAsset?.data;

      }

      if (level === 2) {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
          // authorized: true,

        };

        const getresponseAsset = await axios.get(
          `${BemsGraph}/api/AssetReport/GetAssertReportLevelTwo`,
          {
            params: updatedAssetDetailsData,
            ...config
          }
        );
        return getresponseAsset?.data;
      }


      if (level === 3) {
        const Facilityid = assetDetailsData.facilityid;
        const AssetId = assetDetailsData.assetId;
        if (assetData) {

          const Facilityid = assetDetailsData.facilityid;
          const AssetId = assetDetailsData.assetId;

          response = await axios.get(
            `${BemsGraph}/api/GraphAssetregister/GetAssetDetailsByAssetId/${Facilityid}/${AssetId}`,
            config
          );

        }
      }
      if (level === "Summary") {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        };
        const bemsResponse = await axios.get(`${BemsGraph}/api/AssetReport/GetAssertReportTypeCode`, {
          params: updatedAssetDetailsData,
          ...config,
        });
        const updatedData = bemsResponse?.data?.assetAnalysisTypeCodeList?.map(({ id, facilityId, typeCodeId, assetStatusId, ...rest }) => rest);
        const response = { ...bemsResponse?.data, assetAnalysisTypeCodeList: updatedData };
        return response;

      }
    } else {
      if (level === 1 && groupById != 11) {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        };

        const femsResponse = axios.get(`${FemsGraph}/api/AssetReport/GetAssertReportTypeCode`, {
          params: updatedAssetDetailsData,
          ...config,
        });

        const bemsResponse = axios.get(`${BemsGraph}/api/AssetReport/GetAssertReportTypeCode`, {
          params: updatedAssetDetailsData,
          ...config,
        });
        const [femsData, bemsData] = await Promise.all([femsResponse, bemsResponse]);
        const mergedAssetAnalysisTypeCodeList = groupById == 4 ? [
          ...(femsData?.data?.assetAges || []),
          ...(bemsData?.data?.assetAges || []),
        ] : groupById == 3 ? [
          ...(femsData?.data?.assetStatuses || []),
          ...(bemsData?.data?.assetStatuses || []),
        ] : groupById == 1 ? [
          ...(femsData?.data?.assetAnalysisTypeCodeList || []),
          ...(bemsData?.data?.assetAnalysisTypeCodeList || []),
        ] : groupById == 2 ? [
          ...(femsData?.data?.assetAnalysisLocationCodeList || []),
          ...(bemsData?.data?.assetAnalysisLocationCodeList || []),
        ] : [];
        const combinedAssets = groupById == 4 ? Object.values(
          mergedAssetAnalysisTypeCodeList.reduce((acc, obj) => {
            if (!acc[obj.name]) {
              acc[obj.name] = { ...obj }; // Initialize with current object
            } else {
              acc[obj.name].count += obj.count; // Add counts for duplicate assetId
            }
            return acc;
          }, {})
        ) : groupById == 3 ? Object.values(
          mergedAssetAnalysisTypeCodeList.reduce((acc, obj) => {
            if (!acc[obj.assetId]) {
              acc[obj.assetId] = { ...obj }; // Initialize with current object
            } else {
              acc[obj.assetId].count += obj.count; // Add counts for duplicate assetId
            }
            return acc;
          }, {})
        ) : groupById == 2 ? Object.values(
          mergedAssetAnalysisTypeCodeList.reduce((acc, obj) => {
            if (!acc[obj.departmentCode]) {
              acc[obj.departmentCode] = { ...obj }; // Initialize with current object
            } else {
              acc[obj.departmentCode].assetCount += obj.assetCount; // Add counts for duplicate assetId
            }
            return acc;
          }, {})
        ) : groupById == 1 ? Object.values(
          mergedAssetAnalysisTypeCodeList.reduce((acc, obj) => {
            if (!acc[obj.assetId]) {
              acc[obj.assetId] = { ...obj }; // Initialize with current object
            } else {
              acc[obj.assetId].count += obj.count; // Add counts for duplicate assetId
            }
            return acc;
          }, {})
        ) : [];
        let mergedResponse = groupById == 4 ? {
          ...femsData?.data,
          assetAges: combinedAssets,
        } : groupById == 3 ? {
          ...femsData?.data,
          assetStatuses: combinedAssets,
        } : groupById == 2 ? {
          ...femsData?.data,
          assetAnalysisLocationCodeList: combinedAssets,
        } : groupById == 1 ? {
          ...femsData?.data,
          assetAnalysisTypeCodeList: mergedAssetAnalysisTypeCodeList,
        } : [];
        return mergedResponse;
      }
      if (level === 1 && groupById == 11) {

        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        };
        const femsResponse = axios.get(`${FemsGraph}/api/AssetReport/GetAssertReportLevelTwo`, {
          params: updatedAssetDetailsData,
          ...config,
        });

        const bemsResponse = axios.get(`${BemsGraph}/api/AssetReport/GetAssertReportLevelTwo`, {
          params: updatedAssetDetailsData,
          ...config,
        });

        const [femsData, bemsData] = await Promise.all([femsResponse, bemsResponse]);

        let mergedResponse = {
          ...femsData?.data,
          assetAnalysisLevelTwo: [...femsData?.data?.assetAnalysisLevelTwo || [], ...bemsData?.data?.assetAnalysisLevelTwo || []], // Safely merging arrays
        };
        // Return the merged assetAnalysisLevelTwo value directly if needed
        return mergedResponse;

      }
      if (level === 2) {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        };
        const femsResponse = axios.get(`${FemsGraph}/api/AssetReport/GetAssertReportLevelTwo`, {
          params: updatedAssetDetailsData,
          ...config,
        });

        const bemsResponse = axios.get(`${BemsGraph}/api/AssetReport/GetAssertReportLevelTwo`, {
          params: updatedAssetDetailsData,
          ...config,
        });

        const [femsData, bemsData] = await Promise.all([femsResponse, bemsResponse]);

        let mergedResponse = {
          ...femsData?.data,
          assetAnalysisLevelTwo: [...femsData?.data?.assetAnalysisLevelTwo || [], ...bemsData?.data?.assetAnalysisLevelTwo || []], // Safely merging arrays
        };
        // Return the merged assetAnalysisLevelTwo value directly if needed
        return mergedResponse;
      }
      if (level === "Summary") {
        updatedAssetDetailsData = {
          ...assetData,
          groupById: groupById,
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        };
        const bemsResponse = await axios.get(`${BemsGraph}/api/AssetReport/GetAssertReportTypeCode`, {
          params: updatedAssetDetailsData,
          ...config,
        });
        const updatedData = bemsResponse?.data?.assetAnalysisTypeCodeList?.map(({ id, facilityId, typeCodeId, assetCount, assetStatusId, ...rest }) => rest);
        const response = { ...bemsResponse?.data, assetAnalysisTypeCodeList: updatedData };
        return response;

      }
      if (level === 3) {

        const Facilityid = assetDetailsData.facilityid;
        const AssetId = assetDetailsData.assetId;
        const service = assetDetailsData.service;
        let femsResponse;
        let bemsResponse;
        // Merge data from FEMS and BEMS
        if (service == "FEMS") {
          femsResponse = await axios.get(`${FemsGraph}/api/GraphAssetregister/GetAssetDetailsByAssetId/${Facilityid}/${AssetId}`, {
            params: updatedAssetDetailsData,
            ...config,
          });
          response = {
            data: femsResponse?.data || [],
          };
        } else if (service == "BEMS") {
          bemsResponse = await axios.get(`${BemsGraph}/api/GraphAssetregister/GetAssetDetailsByAssetId/${Facilityid}/${AssetId}`, {
            params: updatedAssetDetailsData,
            ...config,
          });
          response = {
            data: bemsResponse?.data || [],
          };
        }



        return response?.data;
      }

    }
    return response?.data ? response?.data : [];
  }
  catch (error) {
    console.error(error);
  }

};


const fetchWOTypes = async (selectedCategory) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${FemsGraph}/api/Femworkrequesttypelist/Getworkrequestordertype/${selectedCategory}`, config);
    return response?.data;

  } catch (error) {
    console.error('Error fetching types:', error);
  }
};




const AssetRepository = {
  compareObjects,
  isDataChanged,

  getWorkGroupDetails,
  assetNumberGeneration,
  assetListing,
  workGroupCodeDetails,

  filterDetails,
  fetchWOTypes,
  workgroupFilteredRows,
  getWorkorderReport,
  getTaskcdeDetails,
  partReplacement,
  getEmployeeDetails,
  getVendorDetails,
  gettestingandcommissionhistory,
  getcontracthistorydetails,
  getriskmanagmentdetails,
  assetViewDetail,
  addHistoricalCost,
  editHistoricalcostData,
  gethistoricalAssetDetail,
  getAllHistoricalAssetDetail,
  getAssetMaintanceHistory,
  getAuditTrail,
  getSheduledList,
  getUnSheduldedList,
  getRoutineInspectionList,
  exportData,
  exportDataForWorkGroup,
  getHospitalName,
  getAssetReport,
  updateresponseTypeID,
  updatePPMstatusForTrackerTable,
  updateppmplannerisdeleted,
  updatePPMTableandTrackerTableTypeocdeid
};

export default AssetRepository;
